// ============================================================================
// utils_hls.ts
// Utilitaires HLS partagés entre LiveStreamManager et ProductionControlRoom_Deck.
//
// Remplace les deux définitions locales identiques de probeHls().
// ============================================================================

export interface ProbeHlsOptions {
  /**
   * Si true, n'envoie pas le header Range: bytes=0-0.
   * À utiliser pour les sources Xtream passant par le proxy HTTP,
   * dont le CDN peut répondre 407 sur une requête Range.
   */
  skipRange?: boolean;
}

/**
 * Teste la disponibilité d'un flux HLS en effectuant une requête HEAD/GET
 * sur l'URL de la playlist (.m3u8).
 *
 * Retourne true si le serveur répond 200 ou 206 (partial content).
 */
export const probeHls = async (
  url     : string,
  options?: ProbeHlsOptions,
): Promise<boolean> => {
  try {
    const r = await fetch(url, {
      method  : 'GET',
      cache   : 'no-store',
      headers : options?.skipRange ? {} : { Range: 'bytes=0-0' },
    });
    return r.status === 200 || r.status === 206;
  } catch {
    return false;
  }
};